export default function Availability(extendAvailabilityModel, Restangular, AvailabilityUtils) {
  'ngInject';

  Restangular.extendModel('availability', (model) => {
    if (Array.isArray(model)) {
      return model;
    }

    if (!model.user) {
      model.user = {};
    }
    return extendAvailabilityModel(model);
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    let returnElement = element;
    if (
      what === 'availability' &&
      (operation === 'post' || operation === 'put' || operation === 'remove')
    ) {
      returnElement = AvailabilityUtils.transformUnavailabilityForSave(element);
    }

    return returnElement;
  });

  return Restangular.service('availability');
}
